import React from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Loader from '../../../../commons/loader';
import { DatePicker } from '../../../../commons/controls';
import SelectInput, { components } from 'react-select';
import Selector from '../Selector';
import Utility from '../Utility';
import RFForm from '../../../../components/Form/RFForm';
import RFField from '../../../../components/Form/RFField';
import SelectField from '../../../../components/Form/SelectField';

export function ModalNaptarDelete(props) {
  const {
    className,
    isOpen,
    onOKClick,
    toggle,
  } = props;
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader>Törlés</ModalHeader>
      <ModalBody>Biztosan törölni szeretnéd ezt az időpontot?</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onOKClick}>OK</Button>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}

export function ModalNaptar(props) {
  const {
    addNaptar,
    className,
    editNaptar,
    handleDateInputChange,
    handleSzolgaltatasSetState,
    handleTeremSelect,
    handleTimeChange,
    loadSzolgaltatasElement,
    state,
    szolgaltatasStateData,
    toggle,
    toggleIsmetlodesCheck,
    updateIsmetlodesOption,
    updateSzolgaltatasOptions,
  } = props;
  return (
    <Modal isOpen={state.modalNaptar} toggle={toggle} className={className} backdrop="static">
      <RFForm
        modal
        onSubmit={state.insert ? addNaptar : editNaptar}
        title={"Időpont " + (state.insert ? 'felvétel' : 'módosítás')}
        footer={
          <>
            <Button color="primary">Mentés</Button>{' '}
            <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
          </>
        }
      >
        <div>
          <RFField
            label="Terem: *"
            name="teremid"
            type="select"
            value={state.teremFilterSelected}
            onChange={handleTeremSelect}
            disabled={!state.insert}
            required
            defaultSelect={<option value='' disabled>Válassz termet...</option>}
            selectOptions={state.teremOptions}
          />
        </div>
        <div>
          <RFField
            label="Dolgozó: *"
            name="dolgozoid"
            type="select"
            value={state.dolgozoFilterSelected}
            onChange={(event, id) => { updateSzolgaltatasOptions(id); }}
            disabled={!state.teremFilterSelected}
            required
            defaultSelect={<option value={''} disabled>Válassz dolgozót...</option>}
            selectOptions={state.dolgozoOptions}
          />
        </div>
        <Selector
          setState={handleSzolgaltatasSetState}
          loadElementSelected={loadSzolgaltatasElement}
          stateData={szolgaltatasStateData}
          listLabel='Szolgáltatások: *'
          selectorDefaultOptionName='Válassz szolgáltatást...'
          selectorLabel='Szolgáltatás:'
          disabled={!state.dolgozoFilterSelected}
        />
        <div className="row">
          <div className={state.insert ? "col-md-9" : "col-md-12"}
          >
            <DatePicker
              label="Dátum: *"
              id='date'
              name='date'
              value={state.obj && state.obj.date}
              disabled={!state.insert}
              onChange={(date) => handleDateInputChange('date', date)}
            />
          </div>
          {state.insert ?
            <div className="col-md-3">
              <RFField
                label="Ismétlődés"
                type="checkbox"
                name="ismetlodes"
                value={state.ismetlodesCheck}
                onClick={toggleIsmetlodesCheck}
              />
            </div>
            : <div />}
        </div>
        <div className="row">
          <div className="d-flex col-md-6 justify-content-center">
            <div className='col-md-auto'>
              <Label for='kezdet'>Intervallum (-tól): *</Label>
              <RFField
                type='time'
                id='kezdet'
                name='kezdet'
                value={state.obj && state.obj.kezdet}
                onChange={(d) => { handleTimeChange('kezdet', d) }}
              />
            </div>
          </div>
          <div className="d-flex col-md-6 justify-content-center">
            <div className='col-md-auto'>
            <Label for='kezdet'>Intervallum (-ig): *</Label>
              <RFField
                type='time'
                id='vege'
                name='vege'
                value={state.obj && state.obj.vege}
                onChange={(d) => { handleTimeChange('vege', d) }}
              />
            </div>
          </div>
          {state.ismetlodesCheck ?
            <div className="col-md-12" style={{ padding: 0 }}>
              <div className="col-md-12">
                <RFField
                  label="Gyakoriság: *"
                  name="naptarismetlodesenum"
                  type="select"
                  onChange={(event, value) => {
                    updateIsmetlodesOption(value);
                  }}
                  errorMessage="Kötelező mező!"
                  required={state.ismetlodesCheck == true}
                  defaultSelect={<option value={''} disabled>Válassz gyakoriságot...</option>}
                  selectOptions={state.ismetlodesOptions}
                />
              </div>
              {state.ismetlodesSelected == 'NAP' ?
                <div className="row">
                  <div
                    style={{ marginLeft: 10 }}
                  >
                    <RFField
                      label="Szombattal"
                      type="checkbox"
                      name="szombat"
                    />
                  </div>
                  <div>
                    <RFField
                      label="Vasárnappal"
                      type="checkbox"
                      name="vasarnap"
                    />
                  </div>
                </div>
                : <div />}
              <div className="col-md-12">
                <DatePicker
                  label="Ismétlődés vége: *"
                  id='ismetlodesvege'
                  name='ismetlodesvege'
                  onChange={(d) => { handleDateInputChange('ismetlodesvege', d) }}
                />
              </div>
            </div>
            : <div />}
        </div>
      </RFForm>
    </Modal>
  );
}

function renderCard(styleBlock, styleFont, text, iconString, onClick) {
  return (
    <div className="col-md-3 h-100 d-table btn btn-light" style={{ padding: '0 8px' }} onClick={onClick}>
      <div className="d-table-cell align-middle" style={styleBlock}>
        <div className="d-flex justify-content-center" style={styleFont}>
          {text}
        </div>
        <div className="d-flex justify-content-center">
          <i className={"fa fa-3x " + iconString} />
        </div>
      </div>
    </div>
  );
}

function convertDateToString(kezdet, vege) {
  if (kezdet && vege) {
    const options = { hour: '2-digit', minute: '2-digit' };
    const optionsWithYear = { year: 'numeric', month: '2-digit', day: '2-digit', ...options };
    let vegeString = new Date(vege).toLocaleString(undefined, options);
    if (vegeString == '0:00')
      vegeString = '24:00';
    let header = 'Időpont: ' + new Date(kezdet).toLocaleDateString(undefined, optionsWithYear) + ' - ' + vegeString;
    return header;
  }
  return '';
}

export function ModalNaptarChoice(props) {
  const {
    addFoglalas,
    className,
    deleteNaptar,
    editNaptar,
    viewNaptar,
    isOpen,
    state,
    toggle,
  } = props;
  const styleBlock = {
    border: '1px solid #cfd8dc',
  };
  const styleFont = {
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '5px'
  };
  let header = convertDateToString(state.obj.idokezdet, state.obj.idovege);
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static" size='lg'>
      <ModalHeader>
        {header}
      </ModalHeader>
      <ModalBody>
        <div className="row" style={{ height: '200px', padding: '10px' }}>
          {renderCard(styleBlock, styleFont, "Megtekintés", "fa-eye", () => { toggle(); viewNaptar(); })}
          {renderCard(styleBlock, styleFont, "Módosítás", "fa-pencil", () => { toggle(); editNaptar(); })}
          {renderCard(styleBlock, styleFont, "Törlés", "fa-trash", () => { toggle(); deleteNaptar(); })}
          {renderCard(styleBlock, styleFont, "Új foglalás", "fa-calendar-check-o", () => { toggle(); addFoglalas(); })}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}

export function ModalNaptarView(props) {
  const {
    className,
    isOpen,
    toggle,
    state,
  } = props;
  let idotartam = convertDateToString(state.obj.idokezdet, state.obj.idovege);
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader>
        Megtekintés
        </ModalHeader>
      <ModalBody>
        {state.loading ? <Loader /> :
          <div>
            <h6>Adatok</h6>
            <b>Időtartam: </b>{idotartam}<br />
            <b>Terem: </b>{state.obj.teremnev}<br />
            <b>Dolgozó: </b>{state.obj.dolgozonev}<br />
            <b>Szolgáltatás(ok): </b>{state.szolgaltatasViewList}<br />
          </div>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Vissza</Button>
      </ModalFooter>
    </Modal>
  );
}

function foglalasEmailClick(setState) {
  setState({ email: true }, () => {
    let button = document.getElementById('submitFoglalasEdit');
    button.click();
  });
}

export function ModalFoglalas(props) {
  const {
    addFoglalas,
    className,
    deleteFoglalas,
    editFoglalas,
    handleDateInputChange,
    handleSzolgaltatasChange,
    handlePartnerChange,
    handlePartnerModalClick,
    handleTimeChange,
    handleCheckboxChange,
    handleKategoriaSelect,
    setState,
    isOpen,
    isOpenDelete,
    searchPartner,
    state,
    toggle,
    toggleDelete,
  } = props;
  const currentDate = new Date();
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={state.insert ? addFoglalas : editFoglalas}
          title={state.insert ? 'Új foglalás' : 'Foglalás módosítás'}
          footer={
            <>
              <Button color="primary" id='submitFoglalasEdit' hidden={!state.insert && !state.obj.visszaigazolt}>Mentés</Button>
              {!state.insert &&
                <React.Fragment>
                  <Button color="primary" onClick={() => { foglalasEmailClick(setState); }}>Mentés és értesítés</Button>
                  <Button color="primary" onClick={toggleDelete}>Elutasítás</Button>
                </React.Fragment>
              }
              <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
            </>
          }
        >
          <div className="row">
            <div className="col-md-6">
              <RFField
                label="Terem: *"
                name="teremid"
                type="select"
                value={state.teremFilterSelected || (state.obj.terem && state.obj.terem.id)}
                disabled
                selectOptions={state.teremOptions}
              />
              <RFField
                label="Dolgozó: *"
                name="dolgozoid"
                type="select"
                value={state.obj.dolgozoid || (state.obj.dolgozo && state.obj.dolgozo.id)}
                errorMessage="Kötelező mező!"
                disabled
                selectOptions={state.dolgozoOptions}
              />
              <RFField
                label="Szolgáltatás: *"
                name="szolgaltatasid"
                type="select"
                value={state.obj.szolgaltatasid}
                errorMessage="Kötelező mező!"
                required
                disabled={!state.insert}
                onChange={handleSzolgaltatasChange}
                defaultSelect={<option value={''} disabled>Válassz szolgáltatást...</option>}
                selectOptions={state.obj.szolgaltatasOptions}
              />
              <div>
                <DatePicker
                  label="Dátum: *"
                  id='date'
                  name='date'
                  value={state.obj.date}
                  disabled={!state.insert}
                  onChange={(date) => handleDateInputChange('date', date)}
                />
              </div>
              <div>
                <Label for='fogkezdet'>Óra: *</Label>
                <RFField
                  type='time'
                  id='fogkezdet'
                  name='fogkezdet'
                  value={state.obj.fogkezdet}
                  onChange={(d) => { handleTimeChange('fogkezdet', d) }}
                />
              </div>
              <RFField
                label="Időtartam (perc): *"
                name="idotartam"
                value={state.obj.idotartam}
                numberOnlyWhole
              />
            </div>
            <div className="col-md-6">
              <div className="row col-md-12" style={{ marginBottom: '14px' }}>
                <div className="col-md-9">
                  <SelectField
                    variant='async'
                    required
                    label='Ügyfél:'
                    name="partnerid"
                    placeholder="Keresés név alapján..."
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    loadingMessage={() => 'Keresés...'}
                    onChange={v => handlePartnerChange(v)}
                    isClearable
                    loadOptions={_.debounce(searchPartner, 500)}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option && option.nev ? option.nev : ''}
                    // partnerobj.nev mondja meg, hogy "üres" a partner mező vagy sem
                    value={state.partnerobj && state.partnerobj.nev ? state.partnerobj : null}
                    isDisabled={!state.insert}
                  />
                </div>
                <div className="col-md-3">
                  <Label style={{ visibility: 'hidden' }}>Partner</Label>
                  <Button color="primary" onClick={handlePartnerModalClick} disabled={!state.insert} >Új ügyfél</Button>
                </div>
              </div>
              <div className="col-md-12">
                <RFField
                  label="Születési dátum:"
                  name="szul"
                  value={state.partnerobj && state.partnerobj.szulido}
                  disabled
                />
              </div>
              <div className="col-md-12">
                <RFField
                  label="E-mail cím:"
                  name="email"
                  value={state.partnerobj && state.partnerobj.email}
                  disabled
                />
              </div>
              <div className="col-md-12">
                <RFField
                  label="Telefonszám:"
                  name="tel"
                  value={state.partnerobj && state.partnerobj.telefon}
                  disabled
                />
              </div>
              <div className="col-md-12">
                <RFField
                  label="Megjelent"
                  type="checkbox"
                  name="megjelent"
                  value={state.obj.megjelent}
                  onChange={handleCheckboxChange}
                  hidden={state.insert || state.obj.date >= currentDate}
                />
              </div>
              <div className="col-md-12" hidden={state.insert ? false : true}>
                <RFField
                  label="Hírlevél kategória:"
                  type="select"
                  name="kategoriaselect"
                  value={state.kategoriaFilterSelected}
                  onChange={handleKategoriaSelect}
                  defaultSelect={<option value=''>Válassz hírlevél kategóriát...</option>}
                  selectOptions={state.kategoriaOptions}
                />
              </div>
            </div>
            <div className="col-md-6">
              <RFField
                label="Ár (Ft):"
                name="ar"
                value={state.obj.ar}
                numberOnlyWhole
              />
            </div>
            <div className="col-md-6">
              <RFField
                label="Megjegyzés:"
                style={{ height: '120px' }}
                type="textarea"
                name="megjegyzes"
                value={state.obj && state.obj.megjegyzes}
              />
            </div>
          </div>
        </RFForm>
      </Modal>
      <Modal isOpen={isOpenDelete} toggle={toggleDelete} className={className} backdrop="static">
        <RFForm
          modal
          onSubmit={deleteFoglalas}
          title="Biztosan el szeretnéd utasítani a foglalást?"
          footer={
            <>
              <Button color="primary">OK</Button>
              <Button type="button" color="secondary" onClick={toggleDelete}>Mégsem</Button>
            </>
          }
        >
          <RFField
            label="Elutasítás oka: *"
            style={{ height: '120px' }}
            type="textarea"
            name="reason"
            required
          />
        </RFForm>
      </Modal>
    </div>
  );
}

export function ModalPartner(props) {
  const {
    className,
    handlePartnerDateInputChange,
    handleSelectInputChange,
    isOpen,
    onOKClick,
    setOrszaghivo,
    state,
    toggle,
  } = props;
  const Option = ({ children, ...props }) => {
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
    const newProps = Object.assign(props, { innerProps: rest });
    return (
      <components.Option
        {...newProps}
      >
        <div className="flag-format" onClick={() => setOrszaghivo(props.data.num)}>
          <span
            className={'flag-icon flag-icon-' + props.data.name.toLowerCase()}
          />
          <b>{props.data.caption}</b>
          {' '}
          +
          {props.data.num}
        </div>
      </components.Option>
    );
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <RFForm
        modal
        onSubmit={onOKClick}
        title="Új ügyfél"
        footer={
          <>
            <Button color="primary">OK</Button>
            <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
          </>
        }
      >
        <RFField
          label="Partnercsoport: *"
          type="select"
          name="pcsid"
          errorMessage="Kötelező mező!"
          value={state.partnerobj && state.partnerobj.pcsid}
          required
          selectOptions={state.partnercsoportOptions}
        />
        <RFField
          label="Vezetéknév: *"
          name="vezeteknev"
          required
        />
        <RFField
          label="Keresztnév: *"
          name="keresztnev"
          required
        />
        <div>
          <DatePicker
            label="Születési dátum:"
            id='szuletesnap'
            name='szuletesnap'
            onChange={(date) => handlePartnerDateInputChange(date)}
            max={new Date()}
          />
        </div>
        <RFField
          label="E-mail cím: *"
          name="email"
          required
        />
        <div style={{ paddingBottom: 15 }}>
          <Label>Országhívó:</Label>
          <SelectInput
            name="orszaghivo"
            onChange={v => handleSelectInputChange(v, "orszaghivo")}
            components={{ Option }}
            isSearchable={true}
            placeholder="Válassz országot..."
            getOptionLabel={option => option.caption}
            getOptionValue={option => option.num}
            options={state.orszagOptions}
          />
        </div>
        <RFField
          label="Telefonszám:"
          name="tel"
        />
      </RFForm>
    </Modal>
  );
}

export function base(props) {
  const {
    className,
    isOpen,
    onOKClick,
    toggle,
  } = props;
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop="static">
      <ModalHeader></ModalHeader>
      <ModalBody>

      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onOKClick}>OK</Button>
        <Button type="button" color="secondary" onClick={toggle}>Mégsem</Button>
      </ModalFooter>
    </Modal>
  );
}